var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusic = function SvgMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 5.075v-3.37c0-.474-.423-.779-.925-.69L10.02 2.02c-.63.126-.974.44-.974.941l.02 9.965c.049.439-.177.725-.61.806l-1.564.296C4.925 14.403 4 15.317 4 16.67 4 18.041 5.16 19 6.793 19c1.446 0 3.61-.968 3.61-3.575v-8.2c0-.474.099-.573.56-.663l4.496-.896c.334-.062.541-.295.541-.591"
  })));
};
export default SvgMusic;